import { useCurrentUserInfo } from './useCurrentUserInfo';

export const useAppLoadingInfo = ({ history }) => {
  const { isLogin, userHasAnyJob } = useCurrentUserInfo();
  const isLoading = false;
  return { isLoading, isLogin, userHasAnyJob };
};
